import {
  DocumentLinkType,
  DirectUploadDocument,
  DocumentUploaderItem,
  ExistingDocument,
  ExistingPermanentDocument,
  RawExistingDocument,
  RawExistingPermanentDocument,
} from './types/sf-data'

import { ResponsiveBreakpoints, ResponsiveBreakpointsType } from './constants'

export function isDOM(el: Document | Element | null): el is Document {
  return el !== null && 'getElementById' in el
}

export function isDirectUploadDocument(
  doc: DocumentUploaderItem
): doc is DirectUploadDocument {
  return doc.linkType === DocumentLinkType.DirectUpload
}

export function isExistingDocument(
  doc: DocumentUploaderItem
): doc is ExistingDocument {
  return doc.linkType === DocumentLinkType.Document
}

export function isExistingPermanentDocument(
  doc: DocumentUploaderItem
): doc is ExistingPermanentDocument {
  return doc.linkType === DocumentLinkType.PermanentDocument
}

export function isRawExistingDocument(
  doc: RawExistingDocument | RawExistingPermanentDocument
): doc is RawExistingDocument {
  return 'document' in doc
}

export function isBreakpoint(
  breakpoint: string
): breakpoint is ResponsiveBreakpointsType {
  return breakpoint in ResponsiveBreakpoints
}
